import React from 'react'
import styles from './TopBar.module.css'
import IconBack from '../../../../assets/icons/IconBack'

const TopBar = ({
    title,
    onBackClick,
}) => {
    return (
        <div className={styles.container}>
            <IconBack
                size={32}
                className={styles.backButton}
                onClick={onBackClick}/>
            <p className={styles.title}>{title}</p>
            <div style={{ width: '64px' }} />
        </div>
    )
}

export default TopBar
